var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChords1 = function SvgChords1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.804 21.171c.5 0 .804-.237 1.002-.857l1.7-4.983h6.974l1.701 4.983c.211.62.501.857 1.002.857.527 0 .883-.316.883-.804 0-.21-.052-.422-.131-.646L13.279 3.927c-.264-.698-.633-1.041-1.279-1.041-.66 0-1.015.343-1.279 1.041L5.052 19.721c-.079.224-.118.435-.118.646 0 .501.342.804.87.804m3.23-7.356 2.926-8.53h.08l2.913 8.53z"
  })));
};
export default SvgChords1;